import React from "react";

import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";

import { clsx } from "clsx";

import { Link as RouterLink } from "~/components/Link";

/**
 * Used by some legacy components.
 * @deprecated
 */
export const Link = withFocusRing(({ to, ...props }: any) => (
  <RouterLink
    {...props}
    href={to}
    className={clsx(props.className, "hover:text-secondary")}
  />
));
